module.exports = __webpack_public_path__ + "img/curtain_horizontal_75.5b7992f5.svg";